import { render, staticRenderFns } from "./CreateReturnForm.vue?vue&type=template&id=d9e864ca"
import script from "./CreateReturnForm.vue?vue&type=script&lang=js"
export * from "./CreateReturnForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports